export default __webpack_public_path__ + "static/media/Icon_polydex.4cc2f5af.svg";